import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { en } from '~shared-components/translations'
import { TranslationMap } from '~shared-components/translations/default'
import { SupportedLanguage } from '~shared-components/utils/enums'

export type TranslationState = {
  currentLanguage: SupportedLanguage
  strings: TranslationMap
}

const translationInitialState: TranslationState = {
  currentLanguage: SupportedLanguage.English,
  strings: en,
}

export const translationsSlice = createSlice({
  initialState: translationInitialState,
  name: 'translations',
  reducers: {
    initTranslations: {
      prepare: (payload: TranslationMap, meta: SupportedLanguage) => ({
        meta,
        payload,
      }),
      reducer: (
        state,
        {
          meta,
          payload,
        }: PayloadAction<TranslationMap, string, SupportedLanguage>,
      ) => {
        state.strings = payload
        state.currentLanguage = meta
      },
    },
  },
})

export default translationsSlice.reducer
